import { Box, Stack, SxProps, Theme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import {
  FormFieldLabelBasicStyles,
  FormFieldLabelStyles,
} from '@/components/form/model/FormFieldLabel.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

type Props = PropsWithChildren & {
  error?: boolean;
  id?: string;
  isRequired?: boolean;
  label: string;
  positionRelative?: boolean;
  sx?: SxProps<Theme>;
};

export const FormFieldLabel: React.FC<Props> = props => {
  const { children, error, id, isRequired, label, positionRelative, sx } = props;

  return (
    <Box
      id={id}
      sx={[
        positionRelative ? FormFieldLabelBasicStyles : FormFieldLabelStyles,
        sx ?? {},
        error ? { color: themeColors.error } : {},
      ].flat()}
    >
      <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
        {label}
        {isRequired && (
          <Box component="span" sx={{ color: themeColors.red }}>
            *
          </Box>
        )}
      </Stack>
      {children}
    </Box>
  );
};
